import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageDescriptorType = MessageDescriptor;

export const messages: {
	heading: MessageDescriptorType;
	description: MessageDescriptorType;
	ctaLinkText: MessageDescriptorType;
	chatPrompt: MessageDescriptorType;
	whyAmISeeingThisReason1: MessageDescriptorType;
	whyAmISeeingThisReason2: MessageDescriptorType;
} = defineMessages({
	heading: {
		id: 'rovo-non-mau-chat-cta-left-nav.heading.v1',
		defaultMessage: 'Unlock your AI teammate',
		description: 'Heading text for non-MAU Rovo Chat CTA banner',
	},
	description: {
		id: 'rovo-non-mau-chat-cta-left-nav.description.v1',
		defaultMessage: 'Rovo connects your tools and knowledge so work gets done for you.',
		description: 'Description text for non-MAU Rovo Chat CTA banner',
	},
	ctaLinkText: {
		id: 'rovo-non-mau-chat-cta-left-nav.cta-link-text',
		defaultMessage: 'Try Rovo now',
		description: 'CTA link text for the non-MAU Rovo Chat CTA banner',
	},
	chatPrompt: {
		id: 'rovo-non-mau-chat-cta-left-nav.chat-prompt',
		defaultMessage:
			'Hi Rovo, list three things you can do right now for me based on my recent work',
		description:
			'Auto-run prompt sent to Rovo Chat when the user clicks the CTA on the non-MAU chat CTA banner',
	},
	whyAmISeeingThisReason1: {
		id: 'rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-1',
		defaultMessage: 'your existing Atlassian products',
		description: 'First reason for showing the Rovo Chat CTA to the user',
	},
	whyAmISeeingThisReason2: {
		id: 'rovo-non-mau-chat-cta-left-nav.why-am-i-seeing-this.reason-2',
		defaultMessage: 'your organization having AI enabled',
		description: 'Second reason for showing the Rovo Chat CTA to the user',
	},
});
